import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
    // plugins: [createPersistedState()],
    state: {
        cartProducts: [],
        isLoggedIn: !!localStorage.getItem('token')
    },

    getters: {
        getProductsInCart: state => state.cartProducts,
        getTotalInCart: state => state.cartProducts.length,
    },

    mutations: {
        ADD_PRODUCT: (state, item) => {
            state.cartProducts.push(item);
        },
        REMOVE_PRODUCT: (state, index) => {
            state.cartProducts.splice(index, 1);
        },
        REMOVE_ALL_PRODUCTS: (state) => {
            state.cartProducts = [];
        },

        LOGIN_USER: (state) => {
            state.isLoggedIn = true;
        },
        LOGOUT_USER: (state) => {
            state.isLoggedIn = false
        }
    },
    actions: {
        addProduct: (context, product) => {
            context.commit('ADD_PRODUCT', product);
        },
        removeProduct: (context, index) => {
            context.commit('REMOVE_PRODUCT', index);
        },
        removeAllProducts: (context) => {
            context.commit('REMOVE_ALL_PRODUCTS');
        }
    }
})